// =============================================================================
// Project Review
// =============================================================================

import actionItems from './actionItems';
import lessonsLearned from './lessonsLearned';
// import transitionMeeting from './mprAgenda';
// import customerExpectations from './mprAgenda';
// import baseAgenda from './mprAgenda';
import baselineAgenda from './baselineAgenda';
import baseExecSum from './baseExecutiveSummary';
import mprAgenda from './mprAgenda';
import mprExecutiveSummary from './mpr-executive-summary/mpr-executive-summary';
import attendees from './attendees';
import mainInfo from './mainInfo';
import scheduleFive from './schedule-five/all';
import revenueProjection from './revenue-projection/all';
import revisedBaseEstimate from './revisedBaseEstimate';
//import {showErrorNotification, showSuccessNotification} from '../global/notifications';
import { openCloseWindow, windowTriggers } from '../global/kendoWindows';
import profitShare from './profit-share/profit-share';

// Main Function
// =============================================================================
export default function(nameController, nameAction, namePage) {
    /*General Widgets and Element creation*/
    jobSelectWidget();
    empSelectWidget();
    windowTriggers();
    openCloseWindow();
    gridExport();
    //Load Action Item Grid for page
    actionItems();
    //Load Attendee Section for page
    attendees();
    displayFinalizedTag();

    /*Setup Page Specific Logic*/
    mainInfo();
    // Run Baseline agenda
    if ($('[data-view="baseline-agenda"]').length) baselineAgenda();
    //Run Schedule Five
    if (nameAction === 'schedulefive') scheduleFive(nameAction, namePage);
    //Run Revised Base Estimate Functions
    if ($('[data-view="revised-base-estimate"]').length) revisedBaseEstimate();
    //Run Mpr Agenda Functions
    baseExecSum();
    //Run Mpr Agenda Functions
    mprAgenda();
    //Run Mpr Executive Summary Functions
    if (nameController === 'mprexecutivesummary' && nameAction === 'mprexecutivesummary') mprExecutiveSummary();
    //Load Lessons Learned page
    lessonsLearned();

    //Initialize Pco Calculator Page
    if (nameAction === 'revenueprojection') revenueProjection();
    if (nameAction === 'projectprofitshare') profitShare();
}

export const displayFinalizedTag = function() {
    let $fTag = $('#finalizedTag'), isFinalized = $('#Finalized').val() == 1 || $('#Finalized').val() === 'True';
    if (isFinalized) {
        $fTag.show();
    } else {
        $fTag.hide();
    }
};

// Job Search Autocomplete
// =============================================================================

export const autocompleteJobSearch = function() {
    const data = ['Project One', 'Project Two'];

    if ($('#job_search').length) {
        $('#job_search').kendoAutoComplete({
            dataSource: data, filter: 'startswith', placeholder: 'Enter project name or job number', separator: ', ',
        });
    }
};

export const jobSelectWidget = function() {
    let $loadProject = $('#btnLoadProject'), $projectTitle = $('#projectTitle');
    if ($loadProject.length && $projectTitle.length) {
        let k_kendoButton = $loadProject.data('kendoButton'), k_jobSearch = $projectTitle.data('kendoAutoComplete');
        $projectTitle.on('change', function() {
            let searchValue = k_jobSearch.value(),
                isValidJob = searchValue != null && !isNaN(parseInt(searchValue.substr(0, 8))) && searchValue.length >= 8;

            k_kendoButton.enable(isValidJob);
        }).on('select', function() {
            //Possibly no longer necessary
            k_kendoButton.enable(true);
        });
    }
};

export const empSelectWidget = function() {
    let $empAutoComplete = $('input[id^=prMprExecSumApprovalEmp_]');

    if ($empAutoComplete.length) {
        $empAutoComplete.on('change', function() {
            let empNum = this.value,
                isValidEmp = empNum.split('-').length > 1 && !isNaN(parseInt(empNum.split('-')[0])),
                role = this.id.split('_')[1];
            $('#mprExecSumApprovalBtn_' + role).data('kendoButton').enable(isValidEmp);
        }).on('select', function() {
            let role = this.element[0].id.split('_')[1];
            $('#mprExecSumApprovalBtn_' + role).data('kendoButton').enable(true);
        });
    }
};

// Grid Export
// =============================================================================

export const gridExport = function() {
    let $exportSelect = $('#export');

    if ($exportSelect.length) {

        $exportSelect.kendoDropDownList({
            optionLabel: 'Export As...', dataTextField: 'text', dataValueField: 'value', dataSource: [
                { text: 'Excel', value: 1 }, { text: 'CSV', value: 2 },
            ],
        });

        $exportSelect.change(function() {
            // event.preventDefault();
            let value = this.value;
            $exportSelect.data('kendoDropDownList').select(0);
            if (value === '1') {
                exportToExcel();
            } else if (value === '2') {
                exportToCSV();
            }
        });

        let exportToExcel = function() {
            let k_grid = $exportSelect.closest('.k-grid.k-widget').data('kendoGrid');
            if (k_grid) k_grid.saveAsExcel();
        }, exportToCSV = function() {
            let k_grid = $exportSelect.closest('.k-grid.k-widget').data('kendoGrid');
            if (k_grid) {
                let gridType = '';
                if ($('#actionItemsGrid').length) {
                    gridType = 'ActionItem';
                } else if ($('#lessonsLearnedGrid').length) {
                    gridType = 'LessonsLearned';
                } else if ($('#RiskRegList').length) {
                    gridType = 'Risks';
                }
                let columns = k_grid.columns, data = k_grid.dataSource.view(), csv = '', dateTime = new Date(), // gridType    = $('#actionItemsGrid').length > 0 ? 'ActionItem' : 'LessonsLearned',
                    fileName = gridType + 'Export_' + dateTime.getFullYear() + (dateTime.getMonth() + 1) + dateTime.getDate() + '.csv',
                    parseStatus = function(statusCode) {
                        switch (statusCode) {
                            case 1 :
                                return 'Open';
                            case 2 :
                                return 'Closed';
                            case 3 :
                                return 'On Hold';
                            default :
                                return 'Invalid Status';
                        }
                    };
                $.each(columns, function(index, item) {
                    let field = item.title || item.field;
                    if (field) {
                        csv += field + ',';
                    }
                });

                csv += '\n';

                $.each(data, function(index, item) {
                    columns.forEach(function(ele) {
                        let field = ele.field;
                        if (field) {
                            if (field === 'aStatus') {
                                csv += parseStatus(item[field]) + ',';
                            } else {
                                csv += (item[ele.field] || '') + ',';
                            }
                        }
                    });
                    csv += '\n';
                });

                if (navigator.msSaveBlob) {
                    // IE 10+
                    navigator.msSaveBlob(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), fileName);
                } else {
                    let encodedUri = 'data:text/csv;charset=utf-8,' + escape(csv);
                    let link = document.createElement('a');
                    link.setAttribute('href', encodedUri);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };
    }
};

// General Functions
// =============================================================================

export const showForms = function() {
    let $topics = $('.topic, .topic--alt');

    $topics.each(function(index, ele) {
        var id = ele.id;

        if (id !== 'CurrentlyViewing') {
            $(ele).show();
            $('li.menu-topics__item [href="#' + id + '"]').parent().show();
        }
    });

    $('.formToToggle').removeClass('hide-v');
};
export const hideForms = function() {
    let $topics = $('.topic, .topic--alt');

    $topics.each(function(index, ele) {
        var id = ele.id;

        if (id !== 'CurrentlyViewing') {
            $(ele).hide();
            $('li.menu-topics__item [href="#' + id + '"]').parent().hide();
        }
    });

    $('.formToToggle').addClass('hide-v');
};
